// Generated by CoffeeScript 2.7.0
var Confirm, newConfirm;

import ModalMixin from 'trunks/vue/admin/mixins/modal.js';

Confirm = Vue.extend({
  mixins: [ModalMixin],
  props: {
    icon: {
      type: String
    },
    type: {
      type: String,
      default: 'default'
    },
    title: {
      type: String,
      default: '确认?'
    },
    message: {
      type: String
    },
    confirmButtonText: {
      type: String,
      default: '确认'
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    }
  },
  template: `<div class="modal confirm"
     :class='statusClass'
     v-animationend.stop='animationEnd'>
  <div class="content" v-animationend.stop ref="content">
    <div class="confirm-header">
        <div class="confirm-icon"
             :class='iconClass'
             v-if='icon'
             v-html='icon'>
        </div>
        <div class="confirm-title" v-html='title'></div>
      </div>
    <div class="confirm-body" v-if='message' v-html='message'></div>
    <div class="confirm-footer">
      <button class="btn-default btn-large outlined" v-if='cancelButtonText' @click='cancel'>{{ cancelButtonText }}</button>
      <button class="btn-large" :class='confirmButtonClass' @click='ensure'>{{ confirmButtonText }}</button>
    </div>
  </div>
</div>`,
  computed: {
    iconClass: function() {
      switch (this.type) {
        case 'default':
          return 'info-text';
        case 'danger':
          return 'error-text';
        default:
          return '';
      }
    },
    confirmButtonClass: function() {
      switch (this.type) {
        case 'danger':
          return 'btn-danger';
        default:
          return '';
      }
    }
  }
});

newConfirm = function(settings = {}) {
  return new Confirm({
    el: settings.el || Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('confirm_container'),
    propsData: settings
  });
};

export {
  newConfirm
};
